const CONTAINER_TYPES = {
  SILO: ["Siló", "Silo"],
  CONTAINER: ["Magtár", "Container"],
};

export default CONTAINER_TYPES;
